import { render, staticRenderFns } from "./VacancyCandidatesApplying.vue?vue&type=template&id=e23d87b8&scoped=true"
import script from "./VacancyCandidatesApplying.vue?vue&type=script&lang=js"
export * from "./VacancyCandidatesApplying.vue?vue&type=script&lang=js"
import style0 from "./VacancyCandidatesApplying.vue?vue&type=style&index=0&id=e23d87b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23d87b8",
  null
  
)

export default component.exports